import { Typography, CircularProgress, Divider, LinearProgress, Tooltip, Box } from "@mui/material";
import { t } from "i18next";

interface Props {
  type: "학습" | "검사";
  count: number;
  totalCount: number;
}

export default function TrainingProgressChip({ type, count, totalCount }: Props) {
  const isValidating = type === "검사";
  const pct = Number.isFinite((count / totalCount) * 100) ? Math.floor((count / totalCount) * 100) : 0;

  return (
    <Tooltip title={`${count} / ${totalCount}${t("SheetUnit")} ${t("Completed")}`} placement="top" arrow>
      <Box
        id="training-progress-component"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          px: "12px",
          py: "4px",
          minWidth: 0, // 부모 폭이 줄면 바/카운트가 같이 줄어든다
          maxWidth: "100%",
          overflow: "hidden",
          borderRadius: "20px",
          border: "0.5px solid",
          borderColor: "grey.300",
          bgcolor: "grey.50",
          cursor: "default",
          transition: "border-color 0.15s",
          "&:hover": { borderColor: "grey.500" },
        }}
      >
        <Typography
          sx={{ fontSize: "12px", fontWeight: 500, color: "text.primary", whiteSpace: "nowrap", flexShrink: 0 }}
        >
          {t(type === "검사" ? "Inspection" : "Train")}
        </Typography>
        <CircularProgress size={13} thickness={5} color={isValidating ? "warning" : "primary"} sx={{ flexShrink: 0 }} />
        <Divider orientation="vertical" flexItem sx={{ mx: "2px" }} />
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            color: isValidating ? "warning.main" : "primary.main",
            minWidth: "28px",
            textAlign: "right",
            flexShrink: 0,
          }}
        >
          {pct}%
        </Typography>
        <LinearProgress
          variant="determinate"
          value={pct}
          color={isValidating ? "warning" : "primary"}
          sx={{
            width: "88px",
            flexShrink: 1,
            minWidth: "24px",
            height: 5,
            borderRadius: "99px",
            bgcolor: "grey.200",
            "& .MuiLinearProgress-bar": { borderRadius: "99px" },
          }}
        />
        {/* <Typography
          sx={{
            fontSize: "11px",
            color: "text.secondary",
            whiteSpace: "nowrap",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {count} / {totalCount}
          {t("SheetUnit")}
        </Typography> */}
      </Box>
    </Tooltip>
  );
}
